import { FormattedMessage } from "react-intl";
import * as Yup from "yup";

export const subscribeFormSchema = Yup.object().shape({
  password: Yup.string()
    .required(<FormattedMessage id="password-required-validation" />)
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W,_]).{8,16}$/, {
      message: <FormattedMessage id="password-validation" />,
    }),
  reenterPassword: Yup.string()
    .required(<FormattedMessage id="password-required-validation" />)
    .oneOf(
      [Yup.ref("password")],
      <FormattedMessage id="password-match-validation" />,
    ),
  firstName: Yup.string()
    .matches(/^\S*$/, {
      message: <FormattedMessage id="first-name-validation" />,
    })
    .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
      message: <FormattedMessage id="first-name-validation" />,
    })
    .min(2)
    .max(20),
  lastName: Yup.string()
    .matches(/^\S*$/, {
      message: <FormattedMessage id="last-name-validation" />,
    })
    .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
      message: <FormattedMessage id="last-name-validation" />,
    })
    .min(2)
    .max(20),
  email: Yup.string().matches(
    /^[a-zA-Z0-9.!#$%&'*+=?^_]{3,25}@(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z0-9.!#$%&'*+=?^_]{3,25}$/,
    { message: <FormattedMessage id="email-validation" /> },
  ),
  countryCode: Yup.string()
    .matches(
      /^[0-9]*$/,
      <FormattedMessage id="country-code-digit-validation" />,
    )
    .max(5, <FormattedMessage id="country-code-max-validation" />)
    .min(2, <FormattedMessage id="country-code-min-validation" />),
  mobile: Yup.string()
    .matches(/^[0-9]*$/)
    .max(15, <FormattedMessage id="mobile-max-validation" />)
    .min(7, <FormattedMessage id="mobile-min-validation" />),
  username: Yup.string()
    .matches(/^[a-zA-Z0-9.!#$%&'*+=?^_]{3,20}$/, {
      message: <FormattedMessage id="username-validation" />,
    })
    .min(3)
    .max(20),
  address: Yup.string().required(
    <FormattedMessage id="address-required-validation" />,
  ),
  job: Yup.string().required(
    <FormattedMessage id="job-required-validation" />,
  ),
  dob: Yup.string()
    .required(<FormattedMessage id="dob-required-validation" />)
    .test(
      "is-valid-date",
      <FormattedMessage id="invalid-date-validation" />,
      function (value) {
        if (!value) return false;
        try {
          const date = new Date(value + "T00:00:00");
          return (
            !isNaN(date.getTime()) &&
            date >= new Date("1900-01-01") &&
            date <= new Date()
          );
        } catch {
          return false;
        }
      },
    ),
});
